/* eslint-disable prettier/prettier */
import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import GlobalStyles from '../GlobalStyles'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import {
  ThemeProvider as MuiThemeProvider,
  StylesProvider,
  createGenerateClassName
} from '@material-ui/styles'
import ThemeContext from '../Context'
/* webpack-strip-block:removed */
import DarkModeContext from '@signal/theme/Context/dark-mode'
import { replaceThemeColors } from '@signal/core/tenantTheme/utils'
import { 
  /* webpack-strip-block:removed */
  makeLightTheme
} from '@signal/theme/theme'

const defaultGenerateClassName = createGenerateClassName()

export function ThemeProvider(props) {
  const {
    /* webpack-strip-block:removed */
    generateClassName = defaultGenerateClassName,
    children,
    onSiteShadowRootChild
  } = props
  /* webpack-strip-block:removed */
  const lightTheme = makeLightTheme()
  const defaultTheme = useMemo(
    () => ({
      // it is important to clone this object each time, to force MUI to lay down new style tags when the theme
      // changes.  The fact this wasn't always happening, because MUI thought it was clever enough to not always need
      // to apply new styles when changing between dark mode and light mode led to some of the weird leftover colors
      // seen when toggling dark mode in some situations
      ...(
        /* webpack-strip-block:removed */
            ({
               ...lightTheme,
               props: onSiteShadowRootChild ? {
                 ...lightTheme.props,
                 MuiPopover: {
                   container: onSiteShadowRootChild,
                 },
                 MuiPopper: {
                   container: onSiteShadowRootChild,
                 },
                 MuiModal: {
                   container: onSiteShadowRootChild,
                 }
              } : lightTheme.props,       
            })
      )
    }),
    [
      onSiteShadowRootChild,
      lightTheme,
      /* webpack-strip-block:removed */
    ]
  )

  const [values, setValues] = useState(defaultTheme)

  const themeContext = useMemo(
    () => ({
      setValues,
      values
    }),
    [setValues, values]
  )

  const darkModeContext = useMemo(
    () => {
      /* webpack-strip-block:removed */
      return {
        isDarkMode: false,
        canUseDarkMode: false,
        setIsDarkMode: () => {}
      }
    },
    [
      /* webpack-strip-block:removed */
    ]
  )

  return (
    <DarkModeContext.Provider value={darkModeContext}>
      <ThemeContext.Provider value={themeContext}>
        <StylesProvider generateClassName={generateClassName} injectFirst={!onSiteShadowRootChild}>
          <MuiThemeProvider theme={defaultTheme}>
            <StyledThemeProvider theme={defaultTheme}>
              <>
                <GlobalStyles
                  background={values.background}
                  forOnSite={!!onSiteShadowRootChild}
                />
                {children}
              </>
            </StyledThemeProvider>
          </MuiThemeProvider>
        </StylesProvider>
      </ThemeContext.Provider>
    </DarkModeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  tenantTheme: PropTypes.object,
  generateClassName: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
}

export default ThemeProvider
